import { render, staticRenderFns } from "./IconArrow.vue?vue&type=template&id=e47f8b5e"
import script from "./IconArrow.vue?vue&type=script&lang=ts"
export * from "./IconArrow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports